export default "__VITE_ASSET__CAoWEVtj__"